import { useCallback, useMemo } from 'react';
import { useModeloApresentacao } from '../../../config/internal/modelo-apresentacao/modelo-apresentacao.hook';
import { useDispositivoUsuario } from '../use-dispositivo-usuario/use-dispositivo-usuario.hook';
import { HookResult } from './use-app-embarcado.types';

export const useAppEmbarcado = (): HookResult => {
  const { modelo } = useModeloApresentacao();
  const { isDispositivoApple } = useDispositivoUsuario();

  const isAppEmbarcado = useMemo(() => modelo === 'APP_ALUNO', [modelo]);
  const isAppEmbarcadoIos = useMemo(() => isAppEmbarcado && isDispositivoApple, [isAppEmbarcado, isDispositivoApple]);

  const isTabAppEmbarcado = useCallback((tab: string) => {
    const tabsValidas = ['Início', 'Trabalhos', 'Cont. complementar'];
    return tabsValidas.includes(tab);
  }, []);

  return {
    isAppEmbarcado,
    isTabAppEmbarcado,
    isAppEmbarcadoIos,
  };
};
